export const enLang = {
  languageKey: 'en',
  translates: {
    // log_in: 'Log In',
    // log_out: 'Log Out',
    // logout: 'Log Out',
    // logging_in: 'Logging In...',
    // search: 'Search',
    // generate_password: 'Generate password',

    // // language selector:
    // english: 'English',
    // spanish: 'Spanish',
    // portuguese: 'Portuguese',

    // // TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.
    // dashboard: 'Dashboard',
    // profile: 'Profile',
    // my_profile: 'My Profile',
    // detail: 'Detail',
    // edit: 'Edit',
    // 'billing-info': 'Billinf information',
    // 'requester-companies': 'Prescribers',
    // 'supplioer-companies': 'Appraisal companies',
    // list: 'Listado',
    // entities: 'Entidades',
    // // END - TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.

    // // ERRORS
    // required: 'Required field',
    // not_valid_email: 'Not a valid email',
    // // END - ERRORS

    // MENU_dashboard: 'Dashboard',
    // MENU_ORDERS_requests: 'Requests',
    // MENU_ORDERS_list: 'List',
    // MENU_ASSETS_assets: 'Assets',
    // MENU_ASSETS_add: 'Add',
    // MENU_ASSETS_list: 'List',
    // MENU_ASSESSMENTS: 'Assessments',
    // MENU_ASSESSMENTS_add: 'Add Assessment',
    // MENU_ASSESSMENTS_massive_load: 'Massive Load',
    // MENU_ASSESSMENTS_portfolio: 'Portfolio',
    // MENU_ASSESSMENTS_orders: 'Orders',
    // MENU_ASSESSMENTS_orders_all: 'All',
    // MENU_ASSESSMENTS_orders_pendingToAssignManager: 'Pending to Assign a Manager',
    // MENU_ASSESSMENTS_orders_toAssign: 'Pending to Assign a technician',
    // MENU_ASSESSMENTS_orders_pendingToSchedule: 'Pending to Schedule',
    // MENU_ASSESSMENTS_orders_scheduledByTec: 'Schudle by technical',
    // MENU_ASSESSMENTS_orders_inProcess: 'In process',
    // MENU_ASSESSMENTS_orders_deliveredByAppraiser: 'Delivered by technician',
    // MENU_ASSESSMENTS_orders_validationProcess: 'Validation in Progress',
    // MENU_ASSESSMENTS_orders_validated: 'Validated',
    // MENU_ASSESSMENTS_orders_deliveredToClient: 'Delivered to Client',
    // MENU_ASSESSMENTS_orders_alive: 'Appraisals Actives',
    // MENU_ASSESSMENTS_orders_cancelled: 'Cancelled',
    // MENU_ASSESSMENTS_incidents: 'Incidents',
    // MENU_ASSESSMENTS_claims: 'Claims',
    // MENU_QUALITYCONTROL: 'Quality control',
    // MENU_QUALITYCONTROL_createOrder: 'Create order',
    // MENU_QUALITYCONTROL_orders: 'Orders',
    // MENU_QUALITYCONTROL_orders_all: 'All',
    // MENU_QUALITYCONTROL_orders_pendingToAssignProcessManager: 'Pending to Assign Process Manager',
    // MENU_QUALITYCONTROL_orders_pendingToAssignTechnicalManager: 'Pending to Assign Technical Manager',
    // MENU_QUALITYCONTROL_orders_pending2AssignTechnical: 'Pending to Assign Technical',
    // MENU_QUALITYCONTROL_orders_pendingToStartValidation: 'Pending to start Validation',
    // MENU_QUALITYCONTROL_orders_validating: 'Validation in progress',
    // MENU_QUALITYCONTROL_orders_validationFinished: 'Validation finished',
    // MENU_QUALITYCONTROL_orders_deliveredToClient: 'Delivered to Client',
    // MENU_QUALITYCONTROL_orders_alive: 'Appraisals Actives',
    // MENU_QUALITYCONTROL_orders_cancelled: 'Cancelled',
    // MENU_CLAIMS: 'Claims',
    // MENU_ENTITIES: 'Entities',
    // MENU_ENTITIES_prescribers: 'Prescribers',
    // MENU_ENTITIES_customers: 'Customers',
    // MENU_ENTITIES_appraisal_companies: 'Appraisal companies',
    // MENU_ENTITIES_users: 'Users',
    // MENU_CLIENTS: 'Clients',
    // MENU_USERS: 'Users',
    // MENU_USERS_professionals: 'Professionals',
    // MENU_USERS_processManagers: 'Users Process Managers',
    // MENU_USERS_processManagers_list: 'List',
    // MENU_USERS_processManagers_statistics: 'Statistics',
    // MENU_USERS_techManagers: 'Users Technician Managers',
    // MENU_USERS_techManagers_list: 'List',
    // MENU_FINANCIAL: 'Financial',
    // MENU_FINANCIAL_paymentSummary: 'Payment Summary',
    // MENU_FINANCIAL_paymentSummary_allInvoices: 'Todas las facturas',
    // MENU_FINANCIAL_paymentSummary_pendingToSendToInvoicer: 'Pending confirmation request',
    // MENU_FINANCIAL_paymentSummary_sendToRevisionToInvoicer: 'Confirmation sent',
    // MENU_FINANCIAL_paymentSummary_confirmedByInvoicer: 'Confirmed',
    // MENU_FINANCIAL_paymentSummary_rejectedByInvoicer: 'Rejected',

    // MY_PROFILE_MODAL_my_profile: 'My profile',
    // MY_PROFILE_MODAL_save: 'Save',
    // MY_PROFILE_MODAL_confirm: 'Confirm',
    // MY_PROFILE_MODAL_confirming: 'Confirming',
    // MY_PROFILE_MODAL_cancel: 'Cancel',
    // MY_PROFILE_MODAL_cancelling: 'Cancelling',

    // Code: 'Code',
    // code: 'Code',
    // PrescriptorType: 'Prescriptor Type',
    // Name: 'Name',
    // name: 'Name',
    // add_prescriber: 'Add Prescriber',
    // prescribers: 'Prescribers',
    // appraisals: 'Appraisals',
    // users: 'Users',
    // IsActive: 'Active User',
    // FirstName: 'Name',
    // LastName: 'Surname',
    // Requester: 'Prescriber',
    // Email: 'Email',
    // email: 'Email',
    // deliverables: 'Deliverables',
    // billing_info: 'Billing information',
    // typology: 'Typology',
    // cif_nif: 'CIF/NIF',
    // cif: 'CIF',
    // nif: 'NIF',
    // phone: 'Phone Number',
    // description: 'Description',
    // observations: 'observations',
    // IrpfPercentage: 'IRPF retention percentage (%)',
    // BillingTaxType: 'Tax Type',
    // tax: 'Tax',
    // bank_account_number_for_payment: 'Bank Account Number for payment',

    // name_or_business_name: 'Name or business name',
    // withholding: 'Withholding of %IRPF',
    // tax_type: 'Tax type',

    // restart: 'restart',
    // filter: 'Filter',
    // cancel: 'Cancel',
    // save: 'Save',
    // close: 'Close',
    // confirm: 'Confirm',

    // RecordId: 'Record number',
    // GestasaId: 'No. Gestasa',
    // ExternalRecordId: 'External record number',
    // Address: 'Address',
    // address: 'Address',
    // Locality: 'Locality',
    // Province: 'Province',
    // AddedDateTime: 'Creation date',
    // CurrentWorkflowStep: 'Status',
    // ProcessManagerUser: 'Process Manager',
    // TechnicalManagerUser: 'Technical Manager',
    // Customer: 'Customer',
    // customers: 'Customers',

    // postalCode: 'Postal Code',
    // gate: 'Gate',
    // floor: 'Plant',
    // stairs: 'Stairs',
    // entrance: 'Entrance',
    // number: 'Number',
    // streetName: 'Street name',
    // roadType: 'Type of road',
    // change_picture: 'Change Picture',

    // AppraisalStatus_1: '1 - REGISTER',
    // AppraisalStatus_2: '2 - PENDING TO ASSIGN TECHNICIAN',
    // AppraisalStatus_3: '3 - ASSIGNED TO TECHNICIAN',
    // AppraisalStatus_4: '4 - VISIT SCHEDULED',
    // AppraisalStatus_5: '5 - VISIT STARTED',
    // AppraisalStatus_6: '6 - VISITED',
    // AppraisalStatus_7: '7 - REPORT DELIVERED',
    // AppraisalStatus_8: '8 - ASSIGNED TO VALIDATOR',
    // AppraisalStatus_9: '9 - IN VALIDATION PROCESS',
    // AppraisalStatus_10: '10 - VALIDATED',
    // AppraisalStatus_11: '11 - DELIVERED TO CLIENT',

    // DELIVERABLE_REPOSITORY_addRow: '+ Add new deliverable',
    // DELIVERABLE_REPOSITORY_deliverable: 'Deliverable',
    // DELIVERABLE_REPOSITORY_orderType: 'Order type',
    // DELIVERABLE_REPOSITORY_prupose: 'Purpose',
    // DELIVERABLE_REPOSITORY_source: 'Origin',

    // DELIVERABLE_MODAL_deliverable: 'Deliverable',
    // DELIVERABLE_MODAL_documentName: 'Document name',
    // DELIVERABLE_MODAL_generationDate: 'Generation date',
    // DELIVERABLE_MODAL_emissionDate: 'Issue date',
    // DELIVERABLE_MODAL_expirationDate: 'Expiration date',
    // DELIVERABLE_MODAL_documentVersion: 'Document version',
    // DELIVERABLE_MODAL_downloadAll: 'Download all',
    // DELIVERABLE_MODAL_downloading: 'Downloading',
    // DELIVERABLE_MODAL_internal: 'Internal',
    // DELIVERABLE_MODAL_external: 'External',

    // add_new_prescriptor: '+ Add new prescriptor',

    // an_error_has_ocurred: 'An error has occurred',
    // the_action_was_successful: 'The action was successful',
    // successfully_completed: 'Successfully completed',
    // account_number_for_payments: 'Bank account number for payment',

    // PROPERTY_DATA_TABLE_CadastralReference: 'Cadastral reference',
    // PROPERTY_DATA_TABLE_RegistryInfoRegister: 'Property Record',
    // PROPERTY_DATA_TABLE_RegistryInfoRegisterNumber: 'Registry property number',
    // PROPERTY_DATA_TABLE_RegistryInfoIdufir: 'C.R.U. (IDUFIR) ',
    // PROPERTY_DATA_TABLE_RegistryInfoVolume: 'Tome',
    // PROPERTY_DATA_TABLE_RegistryInfoBook: 'Book',
    // PROPERTY_DATA_TABLE_RegistryInfoSection: 'Folio',
    // PROPERTY_DATA_TABLE_RegistryInfoInscription: 'Inscription',
    // PROPERTY_DATA_TABLE_RegistryInfoRealEstateNumber: 'Registered property',
    // PROPERTY_DATA_TABLE_adress: 'Address',
    // PROPERTY_DATA_TABLE_refCatastral: 'Cadastral Ref.',
    // PROPERTY_DATA_TABLE_tipologyAndUse: 'Use and typology',
    // PROPERTY_DATA_TABLE_surface: 'Surface',
    // PROPERTY_DATA_TABLE_antiquity: 'Antiquity',
    // PROPERTY_DATA_TABLE_estimatedValueBand: 'Estimated value range',
    // PROPERTY_DATA_TABLE_total: 'Total:',
    // PROPERTY_DATA_TABLE_prupsedProperty: 'Proposed rate',
    // ORDER_REQUEST_DETAIL_registerData: 'Registry data',
    // ORDER_REQUEST_DETAIL_euro: 'EUROS (without taxes).',

    // ADD_NEW_ASSET_FORM_location: 'Location',
    // ADD_NEW_ASSET_FORM_addManualy: 'Add manually',
    // ADD_NEW_ASSET_FORM_province: 'Province',
    // ADD_NEW_ASSET_FORM_municipality: 'Municipality',
    // ADD_NEW_ASSET_FORM_streetName: 'Path name',
    // ADD_NEW_ASSET_FORM_number: 'Number',
    // ADD_NEW_ASSET_FORM_Block: 'Block',
    // ADD_NEW_ASSET_FORM_Stairs: 'Stair',
    // ADD_NEW_ASSET_FORM_Floor: 'Floor',
    // ADD_NEW_ASSET_FORM_Gate: 'Door',
    // ADD_NEW_ASSET_FORM_Use: 'Use',
    // ADD_NEW_ASSET_FORM_Typologies: 'Typology',
    // ADD_NEW_ASSET_FORM_Surface: 'Surface',
    // ADD_NEW_ASSET_FORM_ConstructionYear: 'Age',
    // ADD_NEW_ASSET_FORM_cadastralReference: 'Cadastral reference',
    // ADD_NEW_ASSET_FORM_propertyRegister: 'Property Record',
    // ADD_NEW_ASSET_FORM_propertyRegisterNumber: 'Registered Estate Number',
    // ADD_NEW_ASSET_FORM_idufir: 'C.R.U (IDUFIR)',
    // ADD_NEW_ASSET_FORM_volume: 'Tome',
    // ADD_NEW_ASSET_FORM_book: 'Book',
    // ADD_NEW_ASSET_FORM_paper: 'Folio',
    // ADD_NEW_ASSET_FORM_inscription: 'Inscription',
    // ADD_NEW_ASSET_FORM_realState: 'Finca',
    // ADD_NEW_ASSET_FORM_add: 'Add',
    // ORDER_REQUEST_DETAIL_addNewAsset: '+ Add new asset',
    // ORDER_REQUEST_DETAIL_cancel: '- Cancel',
    // ORDER_REQUEST_DETAIL_showDetail: 'See detail',

    // InvoiceStatus_0: 'Pending request for confirmation',
    // InvoiceStatus_1: 'Confirmation sent',
    // InvoiceStatus_2: 'Confirmed',
    // InvoiceStatus_3: 'Rejected',

    // MonthsEnum_1: 'January',
    // MonthsEnum_2: 'February',
    // MonthsEnum_3: 'March',
    // MonthsEnum_4: 'April',
    // MonthsEnum_5: 'May',
    // MonthsEnum_6: 'June',
    // MonthsEnum_7: 'July',
    // MonthsEnum_8: 'August',
    // MonthsEnum_9: 'September',
    // MonthsEnum_10: 'October',
    // MonthsEnum_11: 'November',
    // MonthsEnum_12: 'December',

    // financial: 'Financial',
    // 'code-management': 'Code Management',
    // 'payment-summary': 'Payment Summary',
    // 'users-credentials': 'Users with credentials',
    // 'process-manager-user': 'Process Manager User',
    // 'technical-manager-user': 'Technical Manager User',
    // 'commercial-manager-user': 'Commercial manager user',

    // process_managers: 'Process Manager Users',
    // technical_managers: 'Technical Manager Users',
    // commercial_managers: 'Commercial Manager Users',

    // ADD_NEW_ASSET_FORM_postalCode: 'Postal Code',
    // ADD_NEW_ASSET_FORM_streeDoseNotExist: 'Street does not exist',

    // assessments: 'Valoraciones',
    // nationalIdentityDocument: 'National Identity Document',
    // tab_information_updated_please_reload_tab: 'Tab information updated. Reload tab',
    // TECHNICAL_MANAGER_USERS_add_technical_manager_users: 'Add technical manager users',
    // no_documents: 'There are no documents',
    // from: 'From',
    // toDate: 'To',
    // cancelledDate: 'Cancelled date',
    // finishedDate: 'Finished date',

    // REQUESTS_billing: 'Billing',
    // REQUESTS_createNewInvoice: 'Create new invoice',
    // incomeOrExpensesProvision: 'Estimated Income/Expenses',
    // incomeOrExpensesInvoiced: 'Invoiced Income/Expenses',
    // billingType: 'Billing type',
    // billingStatus: 'Billing status',
    // relatedAppraisals: 'Related appraisals',
    // finishedAppraisals: 'Finished Appraisals',
    // appraisalsWithInvoice: 'Appraisals with invoice',
    // amountsSummary: 'Amounts Summary',
    // invoices: 'Invoices',
    // generalData: 'General data',
    // addValorationToRequestInvoice: 'Add Appraisal to Invoice',
    // selectAmountToIncludeInInvoice: 'Select amount to include in the invoice',
    // confirmInvoice: 'Confirm invoice',
    // allInvoiced: 'All invoiced',
    // partialInvoiced: 'Partial invoiced',
    // IndividualByAsset: 'For each asset',
    // GlobalToOrder: 'Global',
    // addAppraisalToInvoiceWarningAutoIndividual: 'The invoice amount will be the sum of the confirmed amounts of the selected valuations.',
    // addAppraisalToInvoiceWarningAutoGlobal: 'The amount of the invoice will be the one indicated after the selection of the valuations.',
    // addAppraisalToInvoiceWarningManual: 'The billing data will be included manually after the selection of the valuations',
    // notInvoiced: 'Not invoiced',
    // filesVolume: 'Files volume',
    // filesAverageTime: 'Average files time',
    // REQUEST_notCancelled: 'Not cancelled',
    // REQUEST_customerInvoiced: 'Only appraisals invoiced to customer',
    // APPRAISALS_notGenerateInvoice: 'Do not bill customer',
    // REPORT_valuation_summary_element: 'Element',
    // REPORT_valuation_summary_registeredPropertyNumber: 'Registry Property',
    // REPORT_valuation_summary_cadastralReference: 'Cadastral Reference',
    // REPORT_valuation_summary_adoptedSurface: 'Adopted Surface (m²)',
    // REPORT_valuation_summary_unitaryValue: 'Unit Value (€/m²)',
    // REPORT_valuation_summary_totalValue: 'Total Value (€)',
    // REPORT_valuation_summary_adoptedMethod: 'Adopted Method',
    // REPORT_reportVersionSelected: 'Report version selected',
    // REPORT_valuationSummary: 'Valuations summary',

    // AVM -TRANSLATES
    AVMNationalBankSpainCutomerTypes_1: 'Banco',
    AVMNationalBankSpainCutomerTypes_2: 'Caja de ahorro',
    AVMNationalBankSpainCutomerTypes_3: 'Cooperativas de crédito',
    AVMNationalBankSpainCutomerTypes_4: 'Establecimiento financiero de crédito y sociedades de garantía recíproca',
    AVMNationalBankSpainCutomerTypes_5: 'Entidades aseguradoras',
    AVMNationalBankSpainCutomerTypes_6: 'Administraciones y organismos públicos',
    AVMNationalBankSpainCutomerTypes_7: 'Institución de inversión colectiva inmobiliaria',
    AVMNationalBankSpainCutomerTypes_8: 'Fondo de pensiones',
    AVMNationalBankSpainCutomerTypes_9: 'Sociedad de gestión de activos',
    AVMNationalBankSpainCutomerTypes_10: 'Otras personas jurídicas',
    AVMNationalBankSpainCutomerTypes_11: 'Personas física',

    AVMPurposes_0: 'NotSpecified',
    AVMPurposes_1: 'Mortgage',
    AVMPurposes_2: 'Awarded',

    avm_my_profile: 'Profile',
    avm_requests: 'Requests',
    avm_list: 'List',
    avm_add: 'Add',
    avm_valuations: 'Valuations',
    avm_dashboard: 'Dashboard',
    avm_massive: 'Massiva',
    avm_portfolios: 'Portfolios',
    avm_incidents: 'Incidents',
    avm_claims: 'Claims',
    avm_quality_control: 'Quality Control',
    avm_simple_notes: 'Simple notes',
    avm_entities: 'avm_entities',
    avm_users: 'Users',
    avm_customers: 'Customers',
    avm_orders: 'Orders',
    avm_isCompany: 'Is Company',
    avm_firstName: 'Firstname',
    avm_lastName: 'Lastname',
    avm_email: 'Email',
    avm_phone: 'Phone',
    avm_nationalBankSpainCode: 'National Bank Spain Code',
    avm_nationalBankSpainCutomerType: 'National Bank Spain Customer Type',
    avm_address: 'Address',
    avm_nationalIdentityDocument: 'DNI',
    avm_phoneNumber: 'Phone Number',
    avm_logoImageFileName: 'Logo image file name',
    avm_add_translation: 'Add translation',
    avm_create_user: 'Create user',
    avm_name: 'Name',
    avm_create: 'Create',
    avm_creating: 'Creating...',
    avm_columns_preselection: 'Columns Preselection',
    avm_profile: 'Profile',
    avm_translations: 'Translations',
    avm_detail: 'Detail',
    avm_customerId: 'Customer ID',
    avm_purpose: 'Valoration purpose',
    avm_customerFullName: 'Customer Full Name',
    avm_addedDateTime: 'Added Date',
    avm_creationDateTime: 'Creation Date',
    avm_hasUsers: 'Has users',
    avm_add_preselection: 'Add preselection',
    avm_edit: 'Edit',
    avm_editing: 'Editing...',
    avm_cancel: 'Cancel',
    avm_cancelling: 'Cancelling',
    avm_save: 'Save',
    avm_saving: 'Saving...',
    avm_fullName: 'Fullname',
    avm_description: 'Description',
    avm_description2: 'Denominators',
    avm_purposes: 'Purposes',
    avm_orderDateTime: 'Order Date',
    avm_create_order: 'Create order',
    avm_create_batch: 'Create Batch',
    avm_add_order: 'Add order',
    avm_input_files: 'Input Files',
    avm_batch: 'Batch',
    avm_batches: 'Batches',
    avm_send_to_client: 'Send to client',
    avm_id: 'Id',
    avm_addedUserFullName: 'Added User Name',
    avm_password: 'Password',
    avm_confirmPassword: 'Confirm Password',
    avm_addedUserId: 'Added User ID',
    avm_lastUpdatedDateTime: 'Last Update Date',
    avm_lastUpdatedUserId: 'Last Update User ID',
    avm_lastUpdatedUserFullName: 'Last Update User Name',
    avm_login_information: 'Login Information',
    avm_logins_log: 'Logins Log',
    avm_select_file: 'Select File',

    InputFileColumns_1: 'InputFileColumns_1',
    InputFileColumns_2: 'InputFileColumns_2',
    InputFileColumns_3: 'InputFileColumns_3',
    InputFileColumns_4: 'InputFileColumns_4',
    InputFileColumns_5: 'InputFileColumns_5',
    InputFileColumns_6: 'InputFileColumns_6',
    InputFileColumns_7: 'InputFileColumns_7',
    InputFileColumns_8: 'InputFileColumns_8',
    InputFileColumns_9: 'InputFileColumns_9',
    InputFileColumns_10: 'InputFileColumns_10',
    InputFileColumns_11: 'InputFileColumns_11',
    InputFileColumns_12: 'InputFileColumns_12',
    InputFileColumns_13: 'InputFileColumns_13',
    InputFileColumns_14: 'InputFileColumns_14',
    InputFileColumns_15: 'InputFileColumns_15',
    InputFileColumns_16: 'InputFileColumns_16',
    InputFileColumns_17: 'InputFileColumns_17',
    InputFileColumns_18: 'InputFileColumns_18',
    InputFileColumns_19: 'InputFileColumns_19',
    InputFileColumns_20: 'InputFileColumns_20',
    InputFileColumns_21: 'InputFileColumns_21',
    InputFileColumns_22: 'InputFileColumns_22',
    InputFileColumns_23: 'InputFileColumns_23',
    InputFileColumns_24: 'InputFileColumns_24',
    InputFileColumns_25: 'InputFileColumns_25',
    InputFileColumns_26: 'InputFileColumns_26',
    InputFileColumns_27: 'InputFileColumns_27',
    InputFileColumns_28: 'InputFileColumns_28',
    InputFileColumns_29: 'InputFileColumns_29',
    InputFileColumns_30: 'InputFileColumns_30',
    InputFileColumns_31: 'InputFileColumns_31',
    InputFileColumns_32: 'InputFileColumns_32',
    InputFileColumns_33: 'InputFileColumns_33',
    InputFileColumns_34: 'InputFileColumns_34',
    InputFileColumns_35: 'InputFileColumns_35',
    InputFileColumns_36: 'InputFileColumns_36',
    InputFileColumns_37: 'InputFileColumns_37',
    InputFileColumns_38: 'InputFileColumns_38',
    InputFileColumns_39: 'InputFileColumns_39',
    InputFileColumns_40: 'InputFileColumns_40',
    InputFileColumns_41: 'InputFileColumns_41',
    InputFileColumns_42: 'InputFileColumns_42',
    InputFileColumns_43: 'InputFileColumns_43',
    InputFileColumns_44: 'InputFileColumns_44',
    InputFileColumns_45: 'InputFileColumns_45',
    InputFileColumns_46: 'InputFileColumns_46',
    InputFileColumns_47: 'InputFileColumns_47',
    InputFileColumns_48: 'InputFileColumns_48',
    InputFileColumns_49: 'InputFileColumns_49',
    InputFileColumns_50: 'InputFileColumns_50',
    InputFileColumns_51: 'InputFileColumns_51',
    InputFileColumns_52: 'InputFileColumns_52',
    InputFileColumns_53: 'InputFileColumns_53',
    InputFileColumns_54: 'InputFileColumns_54',
    InputFileColumns_55: 'InputFileColumns_55',
    InputFileColumns_56: 'InputFileColumns_56',
    InputFileColumns_57: 'InputFileColumns_57',
    InputFileColumns_58: 'InputFileColumns_58',
    InputFileColumns_59: 'InputFileColumns_59',
    InputFileColumns_60: 'InputFileColumns_60',
    InputFileColumns_61: 'InputFileColumns_61',
    InputFileColumns_62: 'InputFileColumns_62',

    avm_save_preselection: 'Save preselection',
    avm_name_preselection: 'Preselection name',
    avm_title_preselection: 'Do you want to save the preselection?',
    avm_rServerApiState: 'Api Server Status',
    avm_rServerApiId: 'Server API ID',
    avm_totalValorationsValue: 'Total value of the valuation',
    avm_cellSeparator: 'Delimiter character',
    avm_batchAssetStates: 'Asset Status',
    avm_batchAssetTypes: 'Asset Types',
    avm_batchAssetOrigins: 'Asset source',
    avm_calculatedAvailableDataStates: 'Asset Information Type - Calculated',
    avm_originAvailableDataStates: 'Asset Information Type - Origin',
    avm_hasAssetCalculated: 'Does it have calculated asset assigned?',
    avm_normalizedProcess: 'Normalization Process',
    avm_normalized: 'The file has already been normalized.',
    avm_noPendingTranslation: 'No translation pending. Confirm to continue.',

    AvailableDataStatesCustom_0: 'No information',
     AvailableDataStatesCustom_1: 'Surface Information',
     AvailableDataStatesCustom_2: 'Type information',
     AvailableDataStatesCustom_3: 'Type and surface information',

    Languages_0: 'Spanish',
    Languages_1: 'English',
    Languages_2: 'Portuguese',

    languagesButton: 'Languages'
  },
};
